import SelectInput from 'CoreComponents/selectInput/';
import PhotographerFilterForm from '../components/photographerFilterForm/';

const SELECTOR = {
  headerCategorySelect: '#headerCategorySelect',
  asideCategorySelect: '#asideCategorySelect',
  filterForm: 'aside .form-photographer-filter'
};

class AdvanceBookingPhotographerScreen {
  constructor() {
    this._setup();
  }

  // Private Methods

  _setup() {
    new SelectInput(document.querySelector(SELECTOR['headerCategorySelect']), {
      addPopper: false
    });
    new SelectInput(document.querySelector(SELECTOR['asideCategorySelect']));

    new PhotographerFilterForm(document.querySelector(SELECTOR['filterForm']));
  }
}

// Setup the AdvanceBookingPhotographerScreen class, only on the photographers page.
let isAdvanceBookingPhotographerPage = document.body.classList.contains('advance-booking-photographers') && document.body.classList.contains('index');

if (isAdvanceBookingPhotographerPage) {
  new AdvanceBookingPhotographerScreen();
}
